<template>

  <popup
    :button-style="isEdit ? 'primary' : 'success'"
    :heading="type"
    size="default"
    button-size="mini"
    :button-text="isEdit ? '' : type"
    :buttonIcon="isEdit ? 'fa fa-edit' : 'fa fa-money-bill'"
    :disableButton="!isManager('finance|management')"
    :circle="isEdit"
    @save="onSaveDialog"
    @close="onCloseDialog">

    <div class="padded">

      <el-row>
        <el-col :span="24">

          <el-alert type="info1" show-icon title="Note!" :description="'This will add this item to every invoice ' + (type === 'Site' ? 'EVERY' :  'THIS') + ' active sharer between start and end dates. After you add this item, can only delete (if system manager finance). Pleae make sure details are correct before you save.'" :closable="false" />

          <h4>Add {{type}}{{name ? ': ' + name :  ''}}</h4>

          <table class="el-table">
              <tbody>
                <tr>
                  <td>Type:&nbsp;<b>{{type}}</b></td>
                  <td><date-input v-model="form.billingStart" placeholder="Start" no-form required  @change="checkRequired" /></td>
                  <td><select-frequency v-model="form.billingPeriod" placeholder="Frequency" label=""  no-form required  @change="checkRequired" /></td>
                  <td><date-input v-model="form.billingExpiry" placeholder="End" no-form /></td>
                </tr>

                <tr>
                  <td>Qty</td>
                  <td>Ref.</td>
                  <td>Desc.</td>
                  <td>Unit Amount</td>
                  <td>{{'Tax: ' + (form.amount ? taxDue(amount) : 'N/A')}}</td>
                </tr>
                <tr>
                  <td><number-input v-model="form.quantity" placeholder="Qty." no-form /></td>
                  <td><text-input v-model="form.ref" placeholder="Ref." no-form /></td>
                  <td><text-input v-model="form.description" placeholder="Description" no-form required @change="checkRequired" /></td>
                  <td><currency-input v-model="form.amount"  placeholder="Unit Amount" label="" no-form required  @change="checkRequired" /></td>
                  <td><currency-input  v-model="form.tax" label="" placeholder="Tax" no-form /></td>
                </tr>

                <tr>
                  <td>Discount</td>
                  <td>
                    <float-input
                        v-model="form.discount"
                        label=""
                        placeholder="Discount"
                        :prefix="form.discountPercentage ? currency : ''"
                        :suffix="form.discountPercentage ? '' : '%'" no-form />
                  </td>
                  <td>
                    <check-box
                      label="Disc. Type"
                      v-model="form.discountPercentage"
                      no-form>
                      {{!form.discountPercentage ? '%' : currency}}
                    </check-box>
                  </td>
                </tr>
                  <tr v-if="discount">
                    <td>Discount <b class="text-danger pull-right">{{formatMoney(this.discount)}}</b></td>
                  </tr>
                  <tr v-if="subTotal !== totals">
                    <td>Sub-Total <b class="text-info pull-right">{{formatMoney(this.subTotal)}}</b></td>
                  </tr>
                  <tr v-if="form.tax">
                    <td>Tax <b class="text-warning pull-right">{{formatMoney(this.form.tax)}}</b></td>
                  </tr>
                  <tr v-if="totals">
                    <td>Total <b class="text-primary pull-right">{{formatMoney(this.totals)}}</b></td>
                  </tr>
              </tbody>
            </table>

        </el-col>
    </el-row>

    </div>
  </popup>

</template>



<script>


import {ENABLE_SAVE_EVENT, DISABLE_SAVE_EVENT, settings} from '@/components/Data'

import SiteMixins from '@/mixins/SiteMixins'


export default {
  mixins: [SiteMixins],

  props: {

    siteId: {
      type: Number,
      required: true
    },

    tableRef: {
      type: String,
      required: true
    },

    sharerId: {
      type: Number,
      default: null
    },

    org: {
      type: Object,
      default: null
    },

    type: {
      type: String,
      default: 'Site Item'
    },

    rowData: {
      type: Object,
      default: null
    }

  },

  methods: {

    onSaveDialog () {

      this.form.type = this.type
      this.form.site_id = this.siteId

      if (this.sharerId) {
        this.form.organisation_id = this.sharerId
      }

      this.form.billingStart = this.formatDateSql(this.form.billingStart)
      this.form.billingExpiry = this.formatDateSql(this.form.billingExpiry)

      this.form.subTotal = this.subTotal
      this.form.totalDiscount = this.discount
      this.form.total = this.totals

      delete this.form.name
      delete this.form.siteId
      delete this.form.siteName
      delete this.form.tableName

      this.saveForm(this, this.url, this.form.id, this.form, this.type + ' Invoice Item', null, null, true, this.tableRef)

    },

    onCloseDialog () {
      this.form = {
        site_id: this.siteId
      }

      if (this.sharerId) {
        this.form.organisation_id = this.sharerId
      }
    },

    checkRequired () {

      if (this.form) {
        if (this.form.billingStart && this.form.billingPeriod && this.form.amount && this.form.description) {
          this.$events.emit(ENABLE_SAVE_EVENT)
        } else {
          this.$events.emit(DISABLE_SAVE_EVENT)
        }
      }

    }

  },

  computed: {

    amount: function () {
      return (this.form.quantity
        ? Number(this.form.amount) * Number(this.form.quantity)
        : Number(this.form.amount))
    },

    discount: function () {
      if (this.form.discount && this.amount) {
        return (this.form.discountPercentage ? Number(this.form.discount) : (this.amount * Number(this.form.discount / 100)))
      } else {
        return 0
      }
    },

    subTotal: function () {
      if (this.amount) {
        return (this.form.quantity
          ? this.amount * Number(this.form.quantity)
          : this.amount) - this.discount
      } else {
        return 0
      }
    },

    totals: function () {
      let t = 0
      if (this.form.tax) {
        t = Number(this.subTotal) + Number(this.form.tax)
      } else {
        t = this.subTotal
      }

      this.form.total = t
      return t
    }

  },


  watch: {
    form: function () {
      this.checkRequired()
    },

    rowData: function (data) {
      this.form = data
    }

  },



  data () {
    return {
      url: '/finance/invoice/' + (this.sharerId ? 'sharers' : 'sites'),
      currency: settings.currency,
      name: (this.org && this.org.organisation ? this.org.organisation.name : ''),
      isEdit: this.rowData ? true : false,
      form: this.rowData ? this.rowData : (this.sharerId ? this.getTableStruct('sharer_invoiceitems') : this.getTableStruct('site_invoiceitems'))
    }
  },

  mounted () {
    if (this.form) {

      if (!this.form.site_id) {
        this.form.site_id = this.siteId
      }

      if (!this.form.site_id && this.sharerId) {
        this.form.organisation_id = this.sharerId
      }

    }

    this.checkRequired()
  }
}

</script>
